<ng-container *transloco="let t">
    <div class="row form-row">
        <div class="col-xs-12">
            <div class="checkbox">
                <label>
                    <input type="checkbox"
                           [(ngModel)]="alleKinderOrte"
                           [ngModelOptions]="{ standalone: true }"
                           (ngModelChange)="selectionChanged()"
                           (blur)="onTouched?.()">
                    <span>{{ t('COMMON.ALLE_KINDERORTE') }}</span>
                </label>
            </div>
        </div>
    </div>

    @if (!alleKinderOrte) {
        <dv-search-list
            entityToSearch="KINDERORT"
            [(ngModel)]="kinderOrte"
            [ngModelOptions]="{ standalone: true }"
            (ngModelChange)="selectionChanged()"
            [orderByText]="true"
            [placeholder]="t('COMMON.KINDERORT.AUSWAEHLEN')"
            [required]="!alleKinderOrte"/>
    }
</ng-container>
